// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if(!window.erpnext) window.erpnext = {};

erpnext.subscribe_to_newsletter = function(opts, btn) {
	return frappe.call({
		type: "POST",
		method: "frappe.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: {"email": opts.email},
		callback: opts.callback
	});
}

// Fix: Prevent Website Users (e.g. employees) from being redirected to /app after login.
// Frappe's default "No App" handler respects `last_visited` which may point to /app,
// causing a "Not Permitted" page. We intercept and skip desk-page redirects.
frappe.ready(function () {
	if (!window.login || !window.login.login_handlers) return;

	var originalHandler = window.login.login_handlers[200];
	window.login.login_handlers[200] = function (data) {
		if (data.message === "No App") {
			login.set_status(__("Success"), "green");

			// Resolve last_visited from localStorage or URL redirect-to param
			var last_visited = null;
			if (localStorage) {
				last_visited =
					localStorage.getItem("last_visited") ||
					frappe.utils.sanitise_redirect(frappe.utils.get_url_arg("redirect-to"));
				localStorage.removeItem("last_visited");
			}

			// Ignore desk-page redirects (Website Users have no access to /app)
			var is_desk_page = last_visited && (
				last_visited === "/app" ||
				last_visited.startsWith("/app/")
			);

			if (last_visited && !is_desk_page && last_visited !== "/login") {
				window.location.href = last_visited;
			} else if (data.redirect_to) {
				window.location.href = frappe.utils.sanitise_redirect(data.redirect_to);
			} else {
				window.location.href = data.home_page;
			}
			return;
		}
		originalHandler.call(this, data);
	};
});
